import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetAllRulesAction } from "../../redux/actions/game.actions";
import { UpdateSelectedTeam } from "../../redux/actions/team.actions";
import { getOneTeam, editTeam } from "../../services/team.services";
import AllRulesModal from "../../UserComponents/modals/AllRulesModal"
import ErrorOverlay from "../../UserComponents/overlays/ErrorOverlay";
import SuccessOverlay from "../../UserComponents/overlays/SuccessOverlay";
import { isEmpty } from "lodash";
import { useHistory } from "react-router-dom";
import "./ChangeTeamRule.css"
import UserSidebar from "../../../components/userSiderbar/userSidebar";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faEdit } from "@fortawesome/free-solid-svg-icons";

const initialState = {
    teamId: "",
    teamName: "",
    teamNickName: "",
    teamColor: "",
    gameRules: "",
    coachName: "",
    coachCell: "",
    coachEmail: "",
    game_rules_setting: null,
};

const ChangeTeamRule = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const user = useSelector((state) => state.auth.user);
    const operatorTeam = useSelector((state) => state.team.selectedTeam);
    const allRules = useSelector((state) => state.gameRules.allRules);

    const [initialStateForm, setInitialStateForm] = useState(initialState);
    const [selectRuleVisible, setSelectRuleVisible] = useState(false);
    const [selectedRule, setSelectedRule] = useState(null);

    const [error, setError] = useState(null);
    const [getTeamLoading, setGetTeamLoading] = useState(false);
    const [updateTeamLoader, setUpdateTeamLoader] = useState(false);
    const [successVisible, setSuccessVisible] = useState(false);

    const toggleSuccessModal = () => {
        setSuccessVisible(!successVisible);
        setTimeout(() => {
            setSuccessVisible(false);
        }, 2500);
    };

    const handleFormChange = (name, value) => {
        setInitialStateForm((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    useEffect(() => {
        dispatch(GetAllRulesAction(user?.token));
    }, [dispatch, user?.token]);

    useEffect(() => {
        (async () => {
            try {
                setGetTeamLoading(true);
                let response = await getOneTeam(operatorTeam?.teamId._id, user?.token);
                handleFormChange("teamId", response.data._id);
                handleFormChange("teamName", response.data.teamName);
                handleFormChange("teamNickName", response.data.teamNickName);
                handleFormChange("teamColor", response.data.teamColor);
                handleFormChange("coachCell", response.data.coachCell);
                handleFormChange("coachEmail", response.data.coachEmail);
                handleFormChange("coachName", response.data.coachName);
                handleFormChange("gameRules", response.data.gameRules);
            } catch (e) {
                console.log("Err at getOneTeam", e);
            } finally {
                setGetTeamLoading(false);
            }
        })();
    }, [operatorTeam, user?.token]);

    const handleUpdate = useCallback(
        async (rule) => {
            try {
                setUpdateTeamLoader(true);
                await editTeam(
                    {
                        teamId: operatorTeam?.teamId._id,
                        gameRules: rule._id,
                    },
                    user?.token
                );

                setSelectRuleVisible(false);
                dispatch(UpdateSelectedTeam(operatorTeam?._id));
                history.push("/teamrules");
            } catch (e) {
                setError(e);
                console.log("Error at EDIT LICENSE team ===>", e.response?.data);
            } finally {
                setUpdateTeamLoader(false);
            }
        },
        [dispatch, history, operatorTeam, user?.token]
    );

    return (
        <div className="changeTeamRule-container">
            {/* Error Modal */}
            {error && (
                <ErrorOverlay
                    onBackdropPress={() => setError(null)}
                    visible={!!error}
                    error={error}
                />
            )}
            <UserSidebar />
            <div className="team-info">
                <h3 className="team-heading">{initialStateForm.teamName}</h3>

                <div className="view-team-rule">
                    <p>
                        Default Game Rules:{" "}
                        {selectedRule
                            ? selectedRule.ruleName
                            : operatorTeam?.teamId.gameRules.ruleName}
                    </p>
                </div>

                <div className="edit-rule">
                    <button
                        className="edit-btn"
                        onClick={() => history.push("/rulessettings")}
                    >
                        {/* <FontAwesomeIcon icon={faEdit} color="green" /> */}
                        Edit Default Game Rules
                    </button>
                </div>

                <p>
                    Gender:{" "}
                    {selectedRule
                        ? selectedRule.gender
                        : operatorTeam?.teamId.gameRules.gender}
                </p>

                <button
                    className="select-rule-btn"
                    onClick={() => setSelectRuleVisible(true)}
                >
                    Select New Rule
                </button>
            </div>

            {/* All Rules Modal */}
            {selectRuleVisible && (
                <AllRulesModal
                    data={allRules || []}
                    setSelectedRule={handleUpdate}   // same purpose as handleSelectGroup
                    groupModal={selectRuleVisible}   // must be groupModal, not isVisible
                    closeModal={() => setSelectRuleVisible(false)}
                    loading={updateTeamLoader}
                />
            )}

            {/* Success Overlay */}
            {successVisible && (
                <SuccessOverlay
                    onBackdropPress={() => toggleSuccessModal(false)}
                    isVisible={successVisible}
                    type="Game Rules changed successfully!"
                    noTick={true}
                />
            )}
        </div>
    );
};

export default ChangeTeamRule;
